module.exports = __webpack_public_path__ + "static/fonts/DINMittelschriftStd.e474bbc.woff";